import type { StripeError } from '@stripe/stripe-js';

/** Stripe errors that are caused by the user, not by us */
export const stripeUserErrorCodes = [
  'setup_intent_authentication_failure', // Payment method fails to authenticate
  'payment_intent_authentication_failure', // Payment method fails to authenticate
];

export const stripeUserErrorTypes = ['card_error', 'validation_error'];

export function isStripeUserError(error?: StripeError): boolean {
  if (!error) {
    return false;
  }
  return (
    stripeUserErrorTypes.includes(error.type || '') ||
    stripeUserErrorCodes.includes(error.code || '')
  );
}
